// globalStyles.js
import { createGlobalStyle } from 'styled-components';
import { Colors } from './app/utils/colors';
 
const GlobalStyle = createGlobalStyle`
  /* Reset CSS */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
  }

  html, body, #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  main {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    display: block;
  }

  ${(props) => {
    if (props.modalShow) {
      return `body, html { overflow: hidden; position:relative; }`;
    }
  }};

  @font-face {
    font-family: 'Parisienne';
    src: url('fonts/Parisienne/Parisienne-Regular.ttf');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'PT_Serif';
    src: url('fonts/PT_Serif/PTSerif-Regular.ttf');
    font-weight: normal;
    font-style: normal;
  }

  .fontCoursive {
    font-family: 'Parisienne', sans-serif;
  }

  .fontTitle, .fontTitle * {
    font-family: 'PT_Serif', sans-serif;
    font-weight: lighter;
  }

  .yellow { color: ${Colors.yellow}; }
  .white { color: ${Colors.white}; }

  .shake {
    animation: shake-animation 0.5s ease infinite;
    transform-origin: 50% 50%;
    display: inline-block;
    will-change: transform;
  }

  @keyframes shake-animation {
    0%, 100% { transform: rotateZ(0deg) }
    25% { transform: rotateZ(-0.5deg) }
    50% { transform: rotateZ(0.5deg) }
    75% { transform: rotateZ(-0.5deg) }
  }
`;
 
export default GlobalStyle;